import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Select from 'react-select'
import InvalidFeedback from "../../components/InvalidFeedback";
import { UsersService } from "../../services/UsersService";
import Button from "../../components/form-controls/Button";
import { AlertService } from "../../services/Alert";
import useModal from "../../hooks/useModal";


interface ModalSubAccountProps {
    subAccountId: any;
    subaccountName: string;
    showSub: boolean;
    getAll: () => void;
    onRequestClose: () => void
}

function ModalAddSubAccount({ getAll, subAccountId, subaccountName, showSub, onRequestClose }: ModalSubAccountProps) {

    const modalSubRef = useRef<HTMLDivElement>(null);

    useModal(modalSubRef, showSub)

    const [subAccountsUser, setSubAccountsUser] = useState<any>([]);

    const defaultValues = {
        subaccount: {
            value: '',
            label: '',
        },
    }

    const { control, handleSubmit, setValue, reset, formState: { isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const getSubAccounts = async () => {
        try {
            const { data } = await UsersService.getSubAccounts({ user_id: subAccountId });
            setSubAccountsUser(data);
        } catch (error) {
            console.log(error);
        }
    }

    const submit = async (data) => {
        try {
            const sendData = {
                user_id: subAccountId,
                area: !data.subaccount.value || data.subaccount.value === -1 ? '' : data.subaccount.label,
                sub_account_id: !data.subaccount.value || data.subaccount.value === -1 ? '' : data.subaccount.value
            }
            await UsersService.changeSubAccount(sendData);
            AlertService.success('¡Éxito!', "Se cambio la subcuenta correctamente", 'Ok');
            closeAndReset();
            getAll();
        } catch (error) {
            console.log(error);
            AlertService.error('¡Error!', "Se ha producido un error inesperado, intenta más tarde");
        }
    }

    const resetModal = () => {
        reset(defaultValues);
    }

    const closeAndReset = () => {
        onRequestClose();
        resetModal();
    }

    const subAccountsUsers = useMemo(() => {
        const noSubaccount = { value: -1, label: 'Agente sin subcuenta' };
        const options = subAccountsUser?.map(s => ({ value: s.id, label: s.name }))

        return [noSubaccount, ...options]
    }, [subAccountsUser]);

    useEffect(() => {
        getSubAccounts();
    }, [subAccountId]);

    useEffect(() => {
        const emptyValue = {
            value: '',
            label: '',
        };
        const defaultValue = subAccountsUsers.find(s => s.label === subaccountName)

        setValue('subaccount', defaultValue || null)
    }, [subAccountsUsers]);

    return (
        <div className="modal fade" ref={modalSubRef} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Cambiar subcuenta</h4>
                            <button type="button" className="btn-close" onClick={closeAndReset}></button>
                        </div>
                        <div className="modal-body">
                            <p>Al asignarle una subcuenta, este agente solo recibirá asignaciones de manera exclusiva de clientes asignados a esta.</p>

                            <div className="mb-3">
                                <label className="form-label">Subcuenta *</label>
                                <Controller
                                    control={control}
                                    name='subaccount'
                                    rules={{ required: true }}
                                    render={
                                        ({
                                            field: { onChange, value },
                                            fieldState: { error }
                                        }) => {
                                            return (
                                                <>
                                                    <Select
                                                        options={subAccountsUsers}
                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                        classNamePrefix='form-select-custom'
                                                        placeholder='Subcuenta'
                                                        onChange={(data: any) => onChange(data)}
                                                        value={value}
                                                    />
                                                    <InvalidFeedback error={error} />
                                                </>
                                            )
                                        }
                                    }
                                />
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={closeAndReset}>Cancelar</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting}>Guardar</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )


}

export default ModalAddSubAccount